/* Todo, discuss, I think it would be beneficial if we had the theme available here */
export default {
  colorLayer: false,
  overlayLayer: false,
  imageLayer: false,
  videoLayer: false,
  color: {
    "type": "solid",
    "color": "var(--color-primary)"
  },
  overlay: {
    "type": "solid",
    "color": "var(--color-secondary50)"
  },
  image: {},
  video: {
    mp4: "https://res.cloudinary.com/ditbeukyz/video/upload/v1603906707/Resources/video_b51tlt.mp4"
  }
}